import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import ErrorBoundary from "./components/ErrorBoundary";

// Lazy load all pages using @ alias (without .tsx extension)
const Home = lazy(() => import("@/pages/Home"));
const Auth = lazy(() => import("@/pages/Auth"));
const Services = lazy(() => import("@/pages/Services"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Contacts = lazy(() => import("@/pages/Contacts"));
const ClientDashboard = lazy(() => import("@/pages/ClientDashboard"));
const NewApplication = lazy(() => import("@/pages/NewApplication"));
const ApplicationDetails = lazy(() => import("@/pages/ApplicationDetails"));
const ApplicationDocuments = lazy(() => import("@/pages/ApplicationDocuments"));
const ApplicationChat = lazy(() => import("@/pages/ApplicationChat"));
const ManagerCRM = lazy(() => import("@/pages/ManagerCRM"));
const AdminPanel = lazy(() => import("@/pages/AdminPanel"));
const Health = lazy(() => import("@/pages/Health"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Loading fallback
const LoadingFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-hero">
    <div className="text-white text-2xl font-semibold animate-pulse">Загрузка...</div>
  </div>
);

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/services" element={<Services />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/app" element={<ClientDashboard />} />
              <Route path="/app/new-application" element={<NewApplication />} />
              <Route path="/app/application/:id" element={<ApplicationDetails />} />
              <Route path="/app/application/:id/documents" element={<ApplicationDocuments />} />
              <Route path="/app/application/:id/chat" element={<ApplicationChat />} />
              <Route path="/crm" element={<ManagerCRM />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/health" element={<Health />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
